import axiosInstance from "./axiosInstance";

const pormocodeApi = {
    applyPromoCode: (userEmail, promoCode, orderId) =>axiosInstance.post("/promocode/checkPromo", {email: userEmail , code:promoCode, orderId})
}

export default pormocodeApi